<app-page
  pageTitle="Zahtevi za kupovinu"
  pageDescription="Upravljajte zahtevima fizičkih i pravnih lica"
>
  @if (stats) {
    <div class="mt-5 flex flex-column md:flex-row gap-4">
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-cube-01 stroke="#414651"></app-cube-01>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Svi zahtevi</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{stats.totalPackages}}</div>
        </div>
      </div>
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-bell-ringing-03 stroke="#414651"></app-bell-ringing-03>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Novi zahtevi</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{stats.newPackages}}</div>
        </div>
      </div>
      <div class="stat-container flex align-items-center flex-1">
        <div class="stat-icon">
          <app-credit-card-02 stroke="#414651"></app-credit-card-02>
        </div>
        <div class="ml-4 flex flex-column">
          <div class="text-sm-semibold text-gray-600">Faktura poslata</div>
          <div class="mt-2 display-sm-semibold text-gray-900">{{stats.awaitingPayment}}</div>
        </div>
      </div>
    </div>
  }
  <app-admin-packages-table (onAction)="load()"></app-admin-packages-table>
</app-page>
